export const Controller = {
  brands: {
    updatebrandbyid: `/api/v2/main/auth/updatebrandbyid`,
    getbrandsbyfilter: `/api/v2/main/getbrandsbyfilter`,
    getaccountbrands: `/api/v2/main/auth/getaccountbrands`,
    getbrandbyid: `/api/v2/main/getbrandbyid`,
  },
  items: {
    getitemsbyids: '/api/v2/main/getitemsbyids',
    getitemsbyfilter: `/api/v2/main/getitemsbyfilter`
  },
  pools: {
    getpoolsinfo: '/api/v2/main/getpoolsinfo',
    /* 1 poolweight; 2: artistpoolweight */
    getpoolsinfobypage: '/api/v2/main/getpoolsinfobypage',
  }
}